import { useContext } from "react";
import { Trans } from "react-i18next";
import { ChatbotStateContext } from "../utils/chatbotContext";

export const ChatbotRoleLabel = () => {
  const chatbotCurrentState = useContext(ChatbotStateContext);

  return (
    <div className="flex-grow h-full md:max-w-lg relative z-40"> {/* z-index has to be higher chatbotnotifications */}
      <div className="flex justify-between items-center">
        <span className="font-unleashed"><Trans>Role</Trans></span>
        <span className="font-semibold text-gray-500 pl-2 pb-1">{chatbotCurrentState.selectedRole}</span>
      </div>
    </div>
  );
};
